import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
//import axios from 'axios'
import './plugins/axios'
import './assets/css/global.css'
import './assets/fonts/iconfont.css'
import Api from "@/api"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$Api = Api
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')